/*** 
 * 描述：点击头像 修改个人信息模态框
 */
import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { $ } from 'protractor';

@Component({
  selector: 'app-sw-person-view',
  templateUrl: './sw-person-view.component.html',
  styleUrls: ['./sw-person-view.component.css']
})
export class SwPersonViewComponent implements OnInit {


  list2 = [{ id: 1, text: "系统用户" }];  //类型
  @ViewChild('personViewModal') personViewModal: SwModalframeComponent; //模态框
  
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件


  UserModel: any = {};  //用户信息
  LoginModel: any = {}; //对象绑定
  entiTy: any = {}; //用户信息
  detail: any = {}; //用户基础信息
  invalid: boolean = false; //判断表单保存是否符合条件
  //用户常用头像
  userImage: any = []

  constructor(
    private user: GetUserModelService, //获取用户信息
    private http: SwHttpClientService, //请求服务
    private jwt :SwJwtService,
    private box: SwMassageBoxService, //提示信息
    private systemId: SystemIdService, 
  ) {
    this.UserModel = this.user.getUser(); //获取用户信息
    if (this.UserModel) {
      this.LoginModel.loginName = this.UserModel['loginName'] //赋值绑定用户名称
    }

  }
 
  ngOnInit() {
    this.userImage = this.user.getUserImage()
    this.detail.fax = this.userImage[0]
    this.ClickLoca()
  }

  //初始化事件
  ClickLoca() {
    //请求参数
    let Params = { ids: [this.UserModel.userId] }
    //请求数据获取用户基础数据
    this.http.Post(environment.seekerWebAPI + "user/queryById", Params).subscribe(
      data => {
        this.personViewModal.toggle();  //打开模态框
        if(data['code'] == 200){
          //用户信息
          this.entiTy = data["data"];
          //用户基础信息
          this.detail = data["data"]["userDetail"]
          this.detail.gender = this.detail.gender + "";
          if(!this.detail.fax){
            this.detail.fax = this.userImage[0]
          }
        }else {
          this.box.danger('获取用户信息失败')
        }
        
        
      })
  } 

  //提交保存用户信息
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      value.systemId = this.systemId.getSystemId()//拿系统id
      if (valid) {
        //请求参数
        let Params = { "entity": this.entiTy, "detail": this.detail }
        //请求保存数据
        let url = environment.seekerWebAPI + "user/updateById";
        this.http.Post(url, Params).subscribe(
          data => {
            //请求成功
            if (data["code"] == 200) {
              //关闭模态框
              this.personViewModal.toggle();
              //抛出事件
              this.callback.emit(false);
              //提示成功
              this.box.success("操作成功")
            } else {
              //关闭模态框
              this.personViewModal.toggle();
              //抛出事件
              this.callback.emit(false);
              //提示错误
              this.box.danger(data["msg"])
            }
          }
        )
      }

    }else {
      this.invalid = true;
      this.box.waringError('请输入完整且正确的信息')
    }
  }

  //转换类型数据
  getTestBed(id) {
    const tem1 = this.list2.filter(item => item['id'] == id)
    if (tem1.length) {
      return tem1[0].text
    }
  }

  //点击取消,先关闭模态框,再销毁组件
  cancel(){
    //关闭模态框
    this.personViewModal.toggle();
    //抛出事件
    this.callback.emit(false);
  }

  //选择用户常用头像
  selectUserImg(item) {
    this.detail.fax = item;
  }
 
}
